import * as React from 'react';

import { FloatingTooltip } from '@coursera-web/cds-labs';

type TooltipWrapperProps = {
  content: string;
  children: React.ReactNode;
  isSideNavCollapsed: boolean;
};

export const SideNavToolTipWrapper = ({ content, children, isSideNavCollapsed }: TooltipWrapperProps) =>
  isSideNavCollapsed ? (
    <FloatingTooltip message={content} placement="right" delayShow={100}>
      <span>{children}</span>
    </FloatingTooltip>
  ) : (
    <>{children}</>
  );

export default SideNavToolTipWrapper;
